(function($) {
    $(document).ready(function() {

        var $rotatingTextContainer = $('.rotating-text');
        var $slides = $rotatingTextContainer.find('.slide');
        var slideCount = $slides.length;
        var currentIndex = 0;
        var intervalTime = 5000; // Time in milliseconds

        // Function to switch slides
        function rotateSlides() {
            // Remove active class from the current slide
            $slides.eq(currentIndex).removeClass('active');

            // Calculate the index of the next slide
            // The modulo (%) operator ensures it wraps around to 0 after the last slide
            currentIndex = (currentIndex + 1) % slideCount;

            // Add active class to the next slide
            $slides.eq(currentIndex).addClass('active');
        }

        // Make the first slide active initially
        if (slideCount > 0) {
            $slides.eq(currentIndex).addClass('active');
        }

        // Set an interval to call rotateSlides every intervalTime milliseconds
        if (slideCount > 1) { // Only rotate if there's more than one slide
             setInterval(rotateSlides, intervalTime);
        }

    });
})(jQuery);